import type { INavigationRoute } from '../../components/sidebar/NavigationRoutes'

export const procurementMainMenuChildren: INavigationRoute[] = [
  {
    name: 'procurement-suppliers',
    displayName: 'menu.suppliers',
    gate: 'supplier',
    meta: {
      icon: 'local_shipping',
    },
  },
]
